import { render, staticRenderFns } from "./SectionContact.vue?vue&type=template&id=19da114b&"
import script from "./SectionContact.vue?vue&type=script&lang=js&"
export * from "./SectionContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports